import type { FetchArgs } from '@reduxjs/toolkit/query/react';
import type { CreateInvoiceRequest } from '../Types/createInvoiceFormTypes';
import type { Invoice } from '../Types/invoicesTypes';

export interface UpdateInvoiceCommandArgs {
  id: number;
  invoice: Partial<Invoice>;
}

export interface LinkPrepaymentsArgs {
  finalInvoiceId: number;
  prepaymentIds: number[];
}

export interface UnlinkPrepaymentsArgs {
  finalInvoiceId: number;
  prepaymentIds?: number[];
}

export interface ReplacePrepaymentsArgs {
  finalInvoiceId: number;
  /** Full target set of prepayments settled by the final invoice. */
  prepaymentIds: number[];
  /** Set linked before the call; used only to invalidate cache tags, never sent. */
  previousPrepaymentIds?: number[];
}

export const buildCreateInvoiceRequest = (payload: CreateInvoiceRequest): FetchArgs => ({
  url: '/invoices',
  method: 'POST',
  body: payload,
});

export const buildUpdateInvoiceCommandRequest = ({
  id,
  invoice,
}: UpdateInvoiceCommandArgs): FetchArgs => ({
  url: `/invoices/${id}`,
  method: 'PUT',
  body: {
    id,
    invoice,
  },
});

export const buildLinkPrepaymentsRequest = ({
  finalInvoiceId,
  prepaymentIds,
}: LinkPrepaymentsArgs): FetchArgs => ({
  url: `/invoices/${finalInvoiceId}/link-prepayments`,
  method: 'POST',
  body: prepaymentIds,
});

export const buildReplacePrepaymentsRequest = ({
  finalInvoiceId,
  prepaymentIds,
}: ReplacePrepaymentsArgs): FetchArgs => ({
  url: `/invoices/${finalInvoiceId}/replace-prepayments`,
  method: 'POST',
  body: prepaymentIds,
});

export const buildUnlinkPrepaymentsRequest = ({
  finalInvoiceId,
  prepaymentIds = [],
}: UnlinkPrepaymentsArgs): FetchArgs => ({
  url: `/invoices/${finalInvoiceId}/unlink-prepayments`,
  method: 'POST',
  body: prepaymentIds,
});
